import './spinner.scss';
import {
	SvgLoadingWheel,
} from 'components/svg/Svg';

interface SpinnerProps {
	height?: string;
	width?: string;
	children?: JSX.Element;
}

const Spinner = ({
	children,
}: SpinnerProps) => {

	return (
		<div className="spinning-child">
			{children}
		</div>
	);
}

export const SvgWheel = ({
	height = '3.5rem',
	width = '3.5rem',
}: SpinnerProps) => (
	<SvgLoadingWheel
		style={{
			width,
			height,
		}}
	/>
);

export default Spinner;